import React, { useState } from 'react';
import {
  List,
  Datagrid,
  TextField,
  ImageField,
  useNotify,
  useRefresh,
  FileInput,
  FileField,
  SimpleForm,
} from 'react-admin';
import { Box } from '@mui/material';

const ImageList = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [uploading, setUploading] = useState(false);

  const handleUpload = async (values) => {
    const file = values.image?.rawFile;
    if (!file) return;

    setUploading(true);
    const formData = new FormData();
    formData.append('image', file);

    try {
      await fetch('http://localhost:3001/api/v1/upload/upload_cloudinary', {
        method: 'POST',
        body: formData,
      });
      notify('Imagen subida correctamente', { type: 'success' });
      refresh();
    } catch (error) {
      console.error(error);
      notify('Error al subir la imagen', { type: 'error' });
    } finally {
      setUploading(false);
    }
  };

  return (
    <Box>
      <List {...props} bulkActionButtons={false}>
        <Datagrid rowClick={false}>
          <TextField source="name" label="Nombre" />
          <ImageField source="url" label="Imagen" />
        </Datagrid>
      </List>

      <Box mt={2} ml={2} width={300}>
        <SimpleForm onSubmit={handleUpload}>
          <FileInput
            source="image"
            label="Subir Imagen"
            accept="image/*"
            maxSize={5000000}
          >
            <FileField source="src" title="title" />
          </FileInput>
        </SimpleForm>
        {uploading && <div>Subiendo imagen...</div>}
      </Box>
    </Box>
  );
};

export default ImageList;
